module.exports = "/images/sq.svg";